module.exports = __webpack_public_path__ + "static/media/staples.5c5dfd80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/where-to-buy/staples.jpg
// module id = 1322
// module chunks = 0